import Vue from "vue";

Vue.component("all-entities-goods-viewer", {
    props: ["data", "classificationHierarchies"],
    data() {
        return {
			isOpen: null,
			isGeneralNoteOpen: null,
			isHsOpen: null,
			classificationSystemItems: null,
			classificationSystemLoading: false,
			activeTab: 0,
			loadedTree: false,
			goodItems: [],
			annexNumber: 0,
			annexId: 0,
			annexLinkCaption: null,
			documents: [],
			exclusions: [],
			generalNoteAnnexId: 0,
			generalNoteAnnexDescription: null,
			generalNotes: [],
			loading: false
        };
    },
	methods: {
		constructUrl: function (annexNumber, annexId) {
			return `~/../Annex${annexNumber}/${annexId}`;
		},		
		openGeneralNote() {
			const self = this;

			self.$services.notes.getByAnnexId({
				annexId: self.generalNoteAnnexId,
				noteType: window.constants.noteType.note,
				language: window.currentLanguage
			}).then((data) => {
				self.generalNotes = data.items;
				self.isGeneralNoteOpen = self.generalNoteAnnexId;
			});
		},
		openInfo(party) {
			console.log(party);
			const self = this;			

			self.isOpen = party.id;			
			self.loading = true;
			self.annexId = party.annexId;

			self.$services.goods.getInfoForAllEntities({
				partyId: party.id,
				classificationSystemId: party.classificationSystemId,
				classificationHierarchyIds: party.classificationHierarchyIds,
				annexId: party.annexId,
				language: window.currentLanguage
			}).then((data) => {				
				self.goodItems = data.goodItems;
				self.annexNumber = data.annexNumber;
				self.annexLinkCaption = data.annexLinkCaption;
				self.documents = data.documents;
				self.exclusions = data.exclusions;
				self.generalNoteAnnexId = data.generalNoteAnnexId;
				self.generalNoteAnnexDescription = data.generalNoteAnnexDescription;				
				self.loading = false;
			});
		},
		getDocImageFile(document) {
			let fileName = 'doc.png';
			switch (document.language) {
				case 'English':
					fileName = 'doc_en.png';
					break;
				case 'French':
					fileName = 'doc_fr.png';
					break;
				case 'Spanish':
					fileName = 'doc_es.png';
					break;
			}

			return '/images/' + fileName;
		},
		getDocTooltip: function(document) {
			let tooltip = window.labels.llsLinkAlt;
			return tooltip.replace('{0}', document.language);
		},
	},
	watch: {
		activeTab: function (value) {
			if (value == 1) {
				this.loadedTree = true;
			}
		}
	},
    template: `
		<div>
			<b-tabs v-model="activeTab">
				<b-tab-item label="Party" value="0">
					<b-collapse
						class="card mb-2"
						animation="slide"
						v-for="party of data"
						:key="'party-' + party.id"
						:open="isOpen == party.id"
						@open="openInfo(party)">
						<template #trigger="props">
							<div class="card-header pt-1 pb-1" role="button">
								<p class="card-header-title">
									{{ party.partyName }}
								</p>
							</div>
						</template>
						<template v-if="loading"><loading></loading></template>
						<template v-else>
							<div class="card-content">
								<div class="content">
									<div v-if="goodItems != null && goodItems.length > 0">
										<b><i>Extract from {{party.coveragePartyName}}'s coverage commitments set out in</i></b>
										<a :href="constructUrl(annexNumber, annexId)" target="_blank"><span style="font-weight: bold" v-html="annexLinkCaption"></span></a>
										<a class="browse-annex-lls-link pr-2" v-for="document in documents" :href="document.document" :title="getDocTooltip(document)" target="_blank">
											<img :src="getDocImageFile(document)" />
										</a>
										<div class="card">
											<div class="card-content">
												<div v-for="goodItem in goodItems" :key="goodItem.id" :id="goodItem.id" class="entity-row">
													<div v-if="goodItem.referenceNumber != null && goodItem.referenceNumber != undefined && goodItem.referenceNumber != ''" class="entity-row-reference-number pr-2">{{goodItem.referenceNumber}}</div>
													<div class="entity-row-display-name" v-html="goodItem.text"></div>
												</div>
												<div class="mt-3" v-if="exclusions && exclusions.length > 0">												
													<div v-for="exclusion in exclusions">
														<b><i class="fas fa-ban has-text-danger"></i><i class="has-text-danger">Exclusion </i><i>from</i></b>
														<a :href="constructUrl(exclusion.annexNumber, exclusion.annexId)" target="_blank"><span style="font-weight: bold" v-html="exclusion.annexLinkCaption"></span></a>
														<a class="browse-annex-lls-link pr-2" v-for="document in exclusion.annexDocuments" :href="document.document" :title="getDocTooltip(document)" target="_blank">
															<img :src="getDocImageFile(document)" />
														</a>
														<exclusion-viewer class="mt-2" :level="0" :exclusions="exclusion.items"></exclusion-viewer>
													</div>
												</div>
											</div>
										</div>
									</div>
									<b-collapse
										v-if="generalNoteAnnexId != null"
										class="card mb-2"
										animation="slide"
										:open="isGeneralNoteOpen == generalNoteAnnexId"
										@open="openGeneralNote">
										<template #trigger="props">
											<div class="card-header pt-1 pb-1" role="button" v>
												<p><b><i>See {{party.coveragePartyName}}'s </i><i v-html="generalNoteAnnexDescription"></i></b></p>
											</div>
										</template>
										<div class="card-content p-1" v-if="generalNotes != null && generalNotes.length > 0">
											<div class="content">
												<annex-notes :level="0" :notes="generalNotes"></annex-notes>
											</div>
										</div>
									</b-collapse>
								</div>
							</div>
						</template>
					</b-collapse>
				</b-tab-item>
				<b-tab-item label="Harmonized Products" value="1">
					<classification-system-items-treeview v-if="loadedTree" :classification-system-id="1" :classification-hierarchies.sync="classificationHierarchies"></classification-system-items-treeview>
				</b-tab-item>
			</b-tabs>					
		</div>
	`
});